/*
  Chrome Vector entrance flow.
  Prefers the real 3D badge + shader chrome melt (cv-logo-3d.js).
  Falls back to the flat-PNG badge and CSS melt when WebGL is unavailable.
*/
(function () {
  'use strict';

  var overlay = document.querySelector('[data-cv-entrance]');
  if (!overlay) return;

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var editor = window.Shopify && window.Shopify.designMode;
  var replay = new URLSearchParams(window.location.search).has('intro');
  var seen = false;
  try { seen = window.localStorage.getItem('cv-logo-intro-seen-v2') === '1'; } catch (e) {}

  if (editor || (!replay && seen)) { overlay.remove(); return; }

  /* Published so the chrome transition can hold its cover until the badge is
     actually on screen. Without it the chrome drains the moment the document
     loads, which on the lobby means revealing an empty stage while three.js is
     still on the wire. Resolves on whichever comes first: the 3D badge booting,
     the flat fallback taking over, or a safety timeout. */
  var signalReady = null;
  if (window.Promise) {
    window.CVEntranceReady = new Promise(function (resolve) { signalReady = resolve; });
    window.setTimeout(function () { if (signalReady) { signalReady(); signalReady = null; } }, 2600);
  }
  function markReady() { if (signalReady) { signalReady(); signalReady = null; } }

  var canvas = overlay.querySelector('[data-cv-logo-canvas]');
  var enterBtn = overlay.querySelector('[data-cv-enter]');
  var gl = null;
  var closing = false;
  var finished = false;
  var fallbackTimer = 0;

  function markSeen() {
    try { window.localStorage.setItem('cv-logo-intro-seen-v2', '1'); } catch (e) {}
  }

  function useFallback() {
    if (overlay.classList.contains('is-gl')) return;
    overlay.classList.add('is-fallback');
    markReady();
    /* Only now does the flat badge actually need to exist. */
    var imgs = overlay.querySelectorAll('img[data-src]');
    for (var i = 0; i < imgs.length; i++) {
      imgs[i].src = imgs[i].getAttribute('data-src');
      imgs[i].removeAttribute('data-src');
    }
  }

  function unlock() {
    document.body.classList.remove('cv-entrance-lock');
  }

  function finish() {
    if (finished) return;
    finished = true;
    window.clearTimeout(fallbackTimer);
    unlock();
    if (gl) { try { gl.dispose(); } catch (e) {} }
    if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
    document.documentElement.classList.add('cv-entrance-complete');
  }

  function enterStore() {
    if (closing) return;
    closing = true;
    markSeen();
    overlay.classList.add('is-melting');

    if (gl) {
      gl.melt({
        onCovered: function () {
          /* Chrome fully covers the viewport here — safe to drop the backdrop
             and hand scrolling back, so what appears underneath is the store. */
          overlay.classList.add('is-covered');
          unlock();
          window.scrollTo(0, 0);
        },
        onDone: function () {
          overlay.classList.add('is-leaving');
          window.setTimeout(finish, 300);
        }
      });
      /* Safety net if a frame callback is missed (tab backgrounded, etc). */
      window.setTimeout(finish, gl.meltDuration + 1400);
      return;
    }

    useFallback();
    unlock();
    window.setTimeout(function () {
      overlay.classList.remove('is-melting');
      overlay.classList.add('is-leaving');
      window.setTimeout(finish, 850);
    }, reduced ? 250 : 1420);
  }

  /* ---- start ---- */

  overlay.hidden = false;
  document.body.classList.add('cv-entrance-lock');
  requestAnimationFrame(function () { overlay.classList.add('is-active'); });

  if (window.CVLogo3D && window.CVLogo3D.supported && canvas && !reduced) {
    /* If the 3D badge has not booted shortly, show the flat one instead. */
    fallbackTimer = window.setTimeout(useFallback, 1800);
    window.CVLogo3D.boot(canvas).then(function (controller) {
      window.clearTimeout(fallbackTimer);
      if (finished) { try { controller.dispose(); } catch (e) {} return; }
      gl = controller;
      overlay.classList.remove('is-fallback');
      overlay.classList.add('is-gl');
      /* One frame later, so the badge has actually painted before the chrome
         above it is allowed to start draining. */
      requestAnimationFrame(function () { requestAnimationFrame(markReady); });
    })['catch'](function () {
      window.clearTimeout(fallbackTimer);
      useFallback();
    });
  } else {
    useFallback();
  }

  /* No timer and no auto-advance: the badge just sits there until the
     visitor chooses to go in. */
  if (enterBtn) {
    enterBtn.addEventListener('click', enterStore);
    /* Build the melt's buffers and compile its program while they are still
       moving toward the button, so the first melted frame is not also the
       frame that allocates a full-screen multisampled target. */
    var warmed = false;
    function warm() {
      if (warmed || !gl || !gl.prewarm) return;
      warmed = true;
      gl.prewarm();
    }
    enterBtn.addEventListener('pointerenter', warm, { passive: true });
    enterBtn.addEventListener('focus', warm, { passive: true });
    enterBtn.addEventListener('touchstart', warm, { passive: true });
  }
})();
